import { useQuery } from '@tanstack/react-query';

import { FlightOperationNotificationClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const FonClient = new FlightOperationNotificationClient(apiBaseUrl);

function useGetFlightOperationNotificationAllSubmissions(history : number = 0) {
  return useQuery({
    queryKey: [queryKeys.FlightOperationNotification.AllSubmissions],
    queryFn: () => FonClient.getAllSubmittedReports(history),
  });
}

export default useGetFlightOperationNotificationAllSubmissions;
